var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowcircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 305.076,
    height: 416.867,
    viewBox: "0 0 305.076 416.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(42.219 -590.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M358.984,492.125c-27.377-66.105-90.869-102.978-155.277-103.255V253.293c84.075.366,167,34.866,224.3,97.982l1.563,1.736q2.136,2.392,4.228,4.844c64.884,76.054,89.381,179.145,66.713,273.81-63.977,8.088-121.8,23.015-169.087,38.5C374.408,617.8,386.428,558.385,358.984,492.125Z",
    transform: "translate(-245.926 336.854)",
    fill: "#f5b85b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowcircle);
export default __webpack_public_path__ + "static/media/yellowcircle.c2c17704f13d961dd55ee5cd8cf561d3.svg";
export { ForwardRef as ReactComponent };